import { combineReducers } from 'redux';

import { GET_CURRENT_USER_FULFILLED, GET_CURRENT_USER_PENDING } from '../../actions';

const initialCurrentUserState = {
  name: '',
  organization: null,
  permissions: [],
  preferredLanguage: ''
};

const pending = (state, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_PENDING:
      return true;
    default:
      return false;
  }
};

const currentUser = (state = initialCurrentUserState, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_FULFILLED:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  pending,
  currentUser
});
